import { render, staticRenderFns } from "./activityEditAssessment.html?vue&type=template&id=065fff1b&scoped=true&external"
import script from "./activityEditAssessment.vue?vue&type=script&lang=js"
export * from "./activityEditAssessment.vue?vue&type=script&lang=js"
import style0 from "./activityEditAssessment.css?vue&type=style&index=0&id=065fff1b&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "065fff1b",
  null
  
)

export default component.exports